import React from "react";
import {
    Avatar,
    Card,
    CardActions,
    CardContent,
    CardHeader, IconButton, ListItemIcon, ListItemText,
    makeStyles, Menu, MenuItem,
    Typography
} from "@material-ui/core";
import {blue, blueGrey, cyan, deepOrange, deepPurple, green} from "@material-ui/core/colors";
import Controls from '../../components/controls/Controls'
import {Link as RouterLink} from 'react-router-dom'
import MoreVertIcon from '@material-ui/icons/MoreVert';
import ViewHeadlineOutlinedIcon from '@material-ui/icons/ViewHeadlineOutlined';
import ViewModuleIcon from '@material-ui/icons/ViewModule';
import {Skeleton} from "@material-ui/lab";

let skeletonHeight = 20;
const useStyles = makeStyles((theme) => ({
    root:{
        height:'100%'
    },
    header: {
        color: theme.palette.primary.dark
    },
    orange: {
        color: theme.palette.getContrastText(deepOrange[500]),
        backgroundColor: deepOrange[500],
    },
    green: {
        color: theme.palette.getContrastText(green[500]),
        backgroundColor: green[500],
    },
    blue: {
        color: theme.palette.getContrastText(blue[500]),
        backgroundColor: blue[500],
    },
    deepPurple: {
        color: theme.palette.getContrastText(deepPurple[500]),
        backgroundColor: deepPurple[500],
    },
    blueGrey: {
        color: theme.palette.getContrastText(blueGrey[500]),
        backgroundColor: blueGrey[500],
    },
    cyan: {
        color: theme.palette.getContrastText(cyan[500]),
        backgroundColor: cyan[500],
    }
}));
export default function InvoiceCard(props) {
    const {
        invoice,
        handleViewDetailLinesClick,
        loading,
        displayPriceField
    } = props;
    const [anchorEl, setAnchorEl] = React.useState(null);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleQuickDetailLineView = (source, invoiceNumber) => {
        handleViewDetailLinesClick(source, invoiceNumber)
        handleClose();
    }

    const classes = useStyles();
    let supportedAvatarBackgroundColors = [classes.orange, classes.green, classes.blue, classes.deepPurple, classes.blueGrey, classes.cyan];

    const getAvatar = (name) => {
        let firstChar;
        let validChar = false;
        for (let i = 0; i < name.length; i++) {
            firstChar = name.charAt(i);
            if (firstChar.match(/[a-z]/i)) { //Check first character is a letter
                validChar = true;
                break;
            }
        }
        if (validChar)
            return <Avatar aria-label={name} className={supportedAvatarBackgroundColors[Math.floor(Math.random() * 6)]}>
                {firstChar.toUpperCase()}
            </Avatar>;
        return null;
    }
    return (

        <Card className={classes.root}>

            <CardHeader
                classes={{title: classes.header}}
                avatar={
                    loading ? (
                        <Skeleton animation='wave' variant='circle' width={40} height={40}/>
                    ) : (
                        getAvatar(invoice.customerName))
                }
                action={
                    loading ? null :
                        <IconButton aria-label="settings" onClick={handleClick}>
                            <MoreVertIcon/>
                        </IconButton>
                }
                title={
                    loading ? (
                            <Skeleton animation='wave' height={skeletonHeight} width='80%' style={{marginBottom: 6}}/>
                        ) :
                        <Typography color='textSecondary'>
                            {invoice.customerName}
                        </Typography>}
                subheader={
                    loading ?
                        (<Skeleton animation="wave" height={skeletonHeight} width="40%"/>) :
                        (`Transaction date: ${invoice.formattedInvoiceDate}`)
                }

            />
            {loading ? null :
                <Menu
                    id="card-menu"
                    anchorEl={anchorEl}
                    keepMounted
                    open={Boolean(anchorEl)}
                    onClose={handleClose}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                >
                    <MenuItem onClick={() => handleQuickDetailLineView(invoice.source, invoice.invoiceNumber)}>
                        <ListItemIcon>
                            <ViewHeadlineOutlinedIcon/>
                        </ListItemIcon>
                        <ListItemText primary='View Detail Lines'/>
                    </MenuItem>
                </Menu>
            }

            <CardContent>
                {loading ?
                    (<React.Fragment>
                        {displayPriceField && <Skeleton animation="wave" height={skeletonHeight} style={{marginBottom: 6}}/> }
                        <Skeleton animation="wave" height={skeletonHeight} width="80%"/>
                        <Skeleton animation="wave" height={skeletonHeight} width="80%"/>
                        <Skeleton animation="wave" height={skeletonHeight} width="80%"/>
                    </React.Fragment>)
                    : (
                        <div>
                            {displayPriceField && <Typography variant="body1" color="textSecondary">Invoice
                                total: {invoice.formattedNett}</Typography>}
                            <Typography variant="body1" color="textSecondary">Detail
                                lines: {invoice.detailLines}</Typography>
                            <div style={{display:'flex'}}>

                                <Typography variant="body1"
                                            color="textSecondary">Available
                                    pickup
                                    lines: {invoice.actionableLines}</Typography>
                                {/*{invoice.actionableLines === 0 ? <CheckIcon color={green[500]}/> : null}*/}
                            </div>
                            <Typography variant="body1"
                                        color="textSecondary">{`Transaction number: ${invoice.invoiceNumber}`}</Typography>
                        </div>
                    )
                }
            </CardContent>
            <CardActions disableSpacing>
                {loading ? (
                        <Skeleton variant='rect' animation="wave" width={100} height={28}/>
                    ) :
                    <Controls.Button
                        text="Proceed to pickup"
                        component={RouterLink}
                        to={`/ViewInvoice/${invoice.source}/${invoice.invoiceNumber}`}
                        startIcon={<ViewModuleIcon>Pickup</ViewModuleIcon>}
                    />
                }
            </CardActions>

        </Card>
    );

}
